import request from './request'

export function listTechGenerator(data) {
  return request.post('/mes/tech-generators/list', data)
}
export function getTechGenerator(id) {
  return request.get('/mes/tech-generators/' + id)
}
export function saveTechGenerator(data) {
  return request.post('/mes/tech-generators', data)
}
export function updateTechGenerator(data) {
  return request.post('/mes/tech-generators/update', data)
}
export function deleteTechGenerator(ids) {
  return request.post('/mes/tech-generators/delete', ids)
}
export function generateTechGenerator(generatorId) {
  return request.post('/mes/tech-generators/generate', { generatorId })
}
